import { render, staticRenderFns } from "./TelaDePerfis.vue?vue&type=template&id=209f5a94&scoped=true&"
import script from "./TelaDePerfis.vue?vue&type=script&lang=ts&"
export * from "./TelaDePerfis.vue?vue&type=script&lang=ts&"
import style0 from "./TelaDePerfis.vue?vue&type=style&index=0&id=209f5a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f5a94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VContainer,VIcon,VTextField})
